"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setIsFullOptionsShown_1 = require("../mutators/setIsFullOptionsShown");
var setSearchTerm_1 = require("../mutators/setSearchTerm");
var collectedOptions_1 = require("../config/collectedOptions");
var updateCategory_1 = require("../orchestrators/updateCategory");
var satcheljs_1 = require("satcheljs");
var getDefaultCategory_1 = require("../utils/getDefaultCategory");
var initializeFullOptionsAction = satcheljs_1.action('initializeFullOptions', function (category, subcategory, option) { return ({
    category: category,
    subcategory: subcategory,
    option: option,
}); });
exports.default = initializeFullOptionsAction;
exports.initializeFullOptionsInternal = satcheljs_1.orchestrator(initializeFullOptionsAction, function (optionsPath) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var category, subcategory, option, categories, categoryKey, subcategoryKey;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                category = optionsPath.category, subcategory = optionsPath.subcategory, option = optionsPath.option;
                setSearchTerm_1.default('');
                setIsFullOptionsShown_1.default(true);
                categories = collectedOptions_1.default();
                categoryKey = category || getDefaultCategory_1.default();
                subcategoryKey = subcategory || getFirstSubCategoryForCategory(categoryKey, categories);
                return [4 /*yield*/, updateCategory_1.default(categoryKey, subcategoryKey, option)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
function getFirstSubCategoryForCategory(categoryKey, categories) {
    var selectedCategory = categories.filter(function (category) { return category.key === categoryKey; })[0];
    return (selectedCategory &&
        selectedCategory.subcategories &&
        selectedCategory.subcategories[0] &&
        selectedCategory.subcategories[0].key);
}
//# sourceMappingURL=initializeFullOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/orchestrators/initializeFullOptions.js
// module id = 4915
// module chunks = 2